export default "__VITE_ASSET__8cfb18fe__"